"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var locale_es_1 = __importDefault(require("../../../translations/locale-es"));
var optionMerchantFilterList = [
    {
        filter: 'Estado',
        key: 'status',
        value: locale_es_1.default['status']['ACTIVE'],
        dbKey: 'ACTIVE',
    },
    {
        filter: 'Estado',
        key: 'status',
        value: locale_es_1.default['status']['INACTIVE'],
        dbKey: 'INACTIVE',
    },
];
exports.default = optionMerchantFilterList;
